const PUBLIC_QUERY_KEYS = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'plan',
  'ref',
])
const PRIVATE_KEY =
  /email|name|password|token|secret|code|portfolio|holding|position|broker|account|customer|subscription|invoice|transaction|user_id|symbol|ticker|balance|pnl|profit|loss|value_usd/i
const EMAIL = /[\w.+-]+@[\w.-]+\.[a-z]{2,}/i
const PROVIDER_ID = /\b(?:sub|cus|cs|in|acct)_[a-z0-9_]+\b/i
const ACCOUNT_ID = /\b[0-9a-f]{8}-[0-9a-f-]{27,}\b/i

/** Analytics URLs contain public campaign labels only; auth and financial context stay local. */
export function analyticsSafeUrl(value: string): string {
  try {
    const base = typeof window === 'undefined' ? 'https://optioneer.io' : window.location.origin
    const url = new URL(value, base)
    if (!['http:', 'https:'].includes(url.protocol)) return '/'
    url.username = ''
    url.password = ''
    url.hash = ''
    for (const key of [...url.searchParams.keys()]) {
      const item = url.searchParams.get(key) || ''
      if (!PUBLIC_QUERY_KEYS.has(key) || EMAIL.test(item) || PROVIDER_ID.test(item)) {
        url.searchParams.delete(key)
      }
    }
    url.pathname = url.pathname.replace(/[0-9a-f]{8}-[0-9a-f-]{27,}/gi, '[record]')
    if (EMAIL.test(decodeURIComponent(url.pathname))) url.pathname = '/[redacted]'
    return /^https?:\/\//.test(value) ? url.toString() : `${url.pathname}${url.search}`
  } catch {
    return '/[redacted]'
  }
}

/** Event helpers accept UI labels; reject accidental sensitive parameters at the boundary. */
export function safeAnalyticsParameters<T extends string | number | boolean | null | undefined>(
  parameters?: Record<string, T>
): Record<string, T> | undefined {
  if (!parameters) return undefined
  return Object.fromEntries(
    Object.entries(parameters).filter(
      ([key, value]) =>
        !PRIVATE_KEY.test(key) &&
        (typeof value !== 'string' ||
          (!EMAIL.test(value) && !PROVIDER_ID.test(value) && !ACCOUNT_ID.test(value)))
    )
  ) as Record<string, T>
}
